<template>
  <v-container>
    <c-card outlined title="그룹 정보" class="mb-5">
      <c-table
          hide-default-footer
          :headers="groupInfoHeader"
          :items="groupInfo"
      >
        <template #type="{ item }">
          {{ item.type ? item.type.configName : '가족' }}
        </template>
        <template #created="{item}">
          {{$func.dateToString(item.created)}}
        </template>
      </c-table>
    </c-card>

    <c-card outlined title="그룹 구성원 정보">
      <c-table
          hide-default-footer
          :headers="groupDetailHeader"
          :items="groupDetailList"
      >
        <template #name="{ item }">
          <span style="cursor: pointer" @click="$router.push(`/customers/${item.customer.id}`)">
            {{ item.customer.name }}
          </span>
        </template>
        <template #joinerName="{ item }">
          <span style="cursor: pointer" @click="$router.push(`/customers/${item.customer.id}`);">
            {{ item.customer.joinerId ? item.customer.joinerId.name : '' }}
          </span>
        </template>
        <template #customerType="{ item }">
          {{ item.customer ? (item.customer.customerType ? item.customer.customerType.configName : '' ) : ''}}
        </template>
        <template #state="{item}">
          {{item.state.configName}}
        </template>
        <template #created="{ item }">
          {{item.state.configName ==='대기' ? '-': $func.dateToString(item.created)}}
        </template>
        <template #registerType="{ item }">
          {{ item.customer ? (item.customer.registerType === 'm.on' ? '온라인' : '오프라인') : ''}}
        </template>
        <template #document="{ item }">
          <c-btn rounded :class="setBtnColors(item)" @click="reqDocumentList(item)">서류</c-btn>
        </template>
      </c-table>
    </c-card>

    <v-dialog v-model="openFlag" max-width="450px" persistent>
      <c-card title="[ 서류 ]" class="white">
        <v-carousel
            height="400"
            hide-delimiter-background
        >
          <v-carousel-item
              v-for="item in documentList"
              :key="item.id"
              :src="$func.getImgUrl(item.photoUrl)"
              @click="openImageDialog(item)"
          ></v-carousel-item>
<!--                    <v-carousel-item-->
<!--                      v-for="(item, idx) in testImage"-->
<!--                      :key="idx"-->
<!--                      :src="item"-->
<!--                      @click="openImageDialog(item)"-->
<!--                    ></v-carousel-item>-->
        </v-carousel>

        <v-row justify="center">
          <c-btn class="mt-2" color="blue" @click="closeDocumentDialog">확 인</c-btn>
        </v-row>
      </c-card>
    </v-dialog>

    <v-dialog v-model="openImageFlag" max-width="60%">
      <v-img :src="openImageSrc" :lazy-src="openImageSrc" style="background-color: white;" aspect-ratio="1"></v-img>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    props: {
      groupDetailList: {
        type: Array
      },
      groupInfo: {
        type: Array
      }
    },
    data: () => ({
      groupInfoHeader: [
        {
          text: '그룹명',
          value: 'name',
          align: 'center',
          sortable: false,
        },
        {
          text: '그룹 유형',
          value: 'type',
          align: 'center',
          sortable: false,
        },
        {
          text: '등록일',
          value: 'created',
          align: 'center',
          sortable: false,
        },
        {
          text: '소속 회원 수',
          value: 'memberCnt',
          align: 'center',
          sortable: false,
        },
        {
          text: '초대 코드',
          value: 'code',
          align: 'center',
          sortable: false,
        },

      ],
      groupDetailHeader: [
        {
          text: '이름',
          value: 'name',
          align: 'center',
          sortable: true,
        },
        {
          text: '신청 회원',
          value: 'joinerName',
          align: 'center',
          sortable: true,
        },
        {
          text: '회원 구분',
          value: 'registerType',
          align: 'center',
          sortable: true,
        },
        {
          text: '회원 유형',
          value: 'customerType',
          align: 'center',
          sortable: true,
        },
        {
          text: '결재 진행 상태',
          value: 'state',
          align: 'center',
          sortable: true,
        },
        {
          text: '그룹 가입일',
          value: 'created',
          align: 'center',
          sortable: true,
        },
        {
          text: '서류',
          value: 'document',
          align: 'center',
          sortable: true,
        },
      ],

      openFlag: false,
      openImageFlag: false,
      openImageSrc: '',

      documentList: [],
    }),
    methods: {
      closeDocumentDialog() {
        this.documentList = [];
        this.openFlag = false;
      },
      openImageDialog(item) {
        this.openImageSrc = this.$func.getImgUrl(item.photoUrl);
        this.openImageFlag = true;
      },
      async reqDocumentList(data) {
        try {
          const customerId = data.customer.id;
          const res = await this.$api.getDocumentList(customerId);

          this.documentList = res.data;
          if (this.documentList.length < 1 ) {
            this.$store.commit('alert', {open: true, msg: '서류가 존재하지 않습니다.'});
            return;
          }
          this.openFlag = true;
        } catch(err) {
          this.$store.commit('snackbar', {err, where: 'reqDocumentList'});
        }
      },
      setBtnColors(data) {
        let memberType = data.customer.registerType;
        return (memberType === 'm.on') ? 'blue' : 'light2Grey';
      },
    },
  }
</script>

<style scoped>

</style>